const courses = [
    {
        path: "/auth",
        component: () => import("../components/Index.vue"),
        meta: {
            requireAuth: true,
        },
        children: [
            {
                path: "login",
                component: () => import("../components/Login.vue"),
                name: "auth.login",
                meta: {
                    requireAuth: true,
                },
            },
        ],
    },
];

export default courses;
